export default function InteractiveCanvas() {
  return (
    <section
      id="canvas"
      className="relative py-28 lg:py-40 px-6 overflow-hidden"
      style={{ background: "linear-gradient(180deg, #06080F 0%, #0D0816 55%, #06080F 100%)" }}
    >
      {/* BG Glows */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(168,85,247,0.07) 0%, transparent 65%)" }}
      />
      <div
        className="absolute bottom-0 right-0 w-96 h-96 rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(20,241,217,0.05) 0%, transparent 70%)" }}
      />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Label */}
        <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-orange mb-6 px-3 py-1 rounded-full border border-brand-orange/30 bg-brand-orange/5">
          아르트레너 진단
        </span>

        {/* Headline */}
        <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-snug lg:leading-relaxed mb-6">
          문화예술 창업에 특화된<br />
          <span className="gradient-text-brand">아르트레너 진단을 받아보세요.</span>
        </h2>

        <p className="text-white/50 font-body text-sm md:text-base leading-loose max-w-xl mx-auto mb-12">
          5가지 질문으로 당신의 예술이 비즈니스가 되는 방법을 찾아드립니다.<br />
          빌더팀이 맞춤형 플랜을 48시간 내에 제안드려요.
        </p>

        {/* Step chips */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-12">
          {[
            { label: "가치 제안", icon: "ri-lightbulb-flash-line" },
            { label: "타겟 팬덤", icon: "ri-group-line" },
            { label: "채널 진단", icon: "ri-wifi-line" },
            { label: "수익 모델", icon: "ri-bar-chart-2-line" },
            { label: "빌딩 포인트", icon: "ri-tools-line" },
          ].map((s, i) => (
            <div
              key={s.label}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-body text-white/50 border border-white/10"
              style={{ background: "rgba(255,255,255,0.03)" }}
            >
              <span className="text-white/25 font-display font-bold">{i + 1}</span>
              <i className={`${s.icon} text-white/30`} />
              <span>{s.label}</span>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <a
          href="/diagnosis"
          className="group inline-flex items-center gap-3 px-8 md:px-10 py-4 md:py-5 rounded-full font-display font-semibold text-base md:text-lg text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          style={{
            background: "linear-gradient(135deg, #A855F7 0%, #7C3AED 100%)",
            boxShadow: "0 0 40px rgba(168,85,247,0.45), 0 0 80px rgba(168,85,247,0.2)",
          }}
        >
          <i className="ri-flashlight-line text-xl" />
          지금 바로 진단 시작하기
          <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
        </a>

        <p className="mt-5 text-xs text-white/25 font-body">
          모든 정보는 빌딩 플랜 제안에만 활용되며 안전하게 보호됩니다
        </p>
      </div>
    </section>
  );
}
